import { get, getWithTimestamp, remove, set } from 'lib/storage/versionedLocalStorageUtils'
import { toUtmParams } from 'lib/url/utmCodesUtils'
import config from 'constants/config'

// Redux state
// Increment version when we change the state structure in an incompatible way.
const REDUX_CART_STATE_KEY = 'checkoutCartReduxState'
const REDUX_CART_STATE_VERSION = 14

const REDUX_FORM_STATE_KEY = 'checkoutFormReduxState'
const REDUX_FORM_STATE_VERSION = 5

const REDUX_PAYMENT_STATE_KEY = 'checkoutPaymentReduxState'
const REDUX_PAYMENT_STATE_VERSION = 8

export function saveCheckoutReduxPaymentState(state: App.Checkout.PaymentState) {
  set(REDUX_PAYMENT_STATE_KEY, REDUX_PAYMENT_STATE_VERSION, state)
}

export function getSavedCheckoutReduxPaymentState(): App.Checkout.PaymentState {
  return get(REDUX_PAYMENT_STATE_KEY, REDUX_PAYMENT_STATE_VERSION)
}

export function saveCheckoutReduxCartState(state: App.CheckoutCartState) {
  set(REDUX_CART_STATE_KEY, REDUX_CART_STATE_VERSION, state)
}

export function getSavedCheckoutReduxCartState() {
  return getWithTimestamp<App.CheckoutCartState>(REDUX_CART_STATE_KEY, REDUX_CART_STATE_VERSION)
}

export function saveCheckoutReduxFormState(state: App.Checkout.FormState) {
  set(REDUX_FORM_STATE_KEY, REDUX_FORM_STATE_VERSION, state)
}

export function getSavedCheckoutReduxFormState(): App.Checkout.FormState {
  return get(REDUX_FORM_STATE_KEY, REDUX_FORM_STATE_VERSION)
}

export function clearFormStateCheckout() {
  remove(REDUX_FORM_STATE_KEY)
}

const REDUX_FORM_STATE_SNAPSHOT_KEY = 'checkoutFormStateSnapshot'
// This localstorage key is no longer used. Let's leave this here for a while to clear it from people's localstorage.
// TODO: Delete this function and all calls to it in maybe late 2025.
export function clearFormStateSnapshot() {
  remove(REDUX_FORM_STATE_SNAPSHOT_KEY)
}

/**
 * svc-cart still expects UTM params
 *
 * @remarks
 * Customer portal no longer uses it, so we keep this implementation isolated to where still need it
 */
export function getUtmParams(utm: App.UTMState) {
  return {
    utm_source: config.BRAND,
    utm_medium: 'web',
    ...toUtmParams(utm),
  }
}
